import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import Slideshow from "../../assets/Slideshow/Slideshow"; 





const Lo2ReadGit = () => {
    const navigate = useNavigate();

    const images = [figma, lowprot1, lowprot2];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo2-headings">
                <h1>Read Me Git</h1>
                <p>I need to show that I could help others understand how to use my project</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>

            <div className="content-lo2">
                <div className="content-lo2-readgit">
                    <div className="content-lo2-readgit-text">
                    {/* <img src={gif2}></img> */}
                        <h1>TEST</h1>
                        <p>
                            I tried to sketch what I want to make for my portfolio and came up with the picture on the right,
                             I asked feedback from Amer and he said that I could try and make this design for my portfolio.
                        </p>
                        
                    </div>

                    <div className="content-lo2-readgit-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo2ReadGit;